import React, { Fragment } from "react";
import CircleRectIcon from "./circleRectIcon";
import SliderWithPercent from "../sliderWithPercent";

const regex = /([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\:\&\s])/g;

const ClassificationGroup = ({
  activePortfolioID,
  classification_validated_data,
  classification_colors,
  minMaxZeroToHundred,
  sliderDisplayHandler,
  getChar,
  sliderRangeHandler,
  displayRangeSlider,
}) => {
  return (
    <Fragment>
      <div className="BuildPortfolio_holder_assetClass_heading">
        Classification :
      </div>
      <div className="BuildPortfolio_holder_assetClass_pills">
        {classification_validated_data.map(
          (el, i) =>
            el.name.toLocaleLowerCase() !== "cash" && (
              <div
                key={`${el.name}-${i}`}
                onClick={(e) =>
                  sliderDisplayHandler(
                    e,
                    `${el.name.replace(
                      regex,
                      ""
                    )}-classification-${i}-${activePortfolioID}`
                  )
                }
              >
                {el && el.name && (
                  <CircleRectIcon
                    fullLabel={el.name}
                    label={getChar({
                      sentence:
                        el.name.toLowerCase() === "mid cap"
                          ? el.name.split(" ").join("")
                          : el.name.toLowerCase() === "multi cap"
                          ? el.name.split(" ").join("")
                          : el.name.toLowerCase() === "mega cap"
                          ? el.name.split(" ").join("")
                          : el.name,
                    })}
                    // color={this.getColors({
                    //   str: el.name.toLowerCase(),
                    //   group: colorClassificationGroup,
                    // })}
                    color={classification_colors[i]}
                    min={el.min * 100}
                    max={el.max * 100}
                    bg_warning={el.slider_error}
                    cursor={
                      displayRangeSlider === false ? "default" : "pointer"
                    }
                    // handler={(e) => this.sliderDisplayHandler(e)}
                  />
                )}
                {displayRangeSlider === false ? null : (
                  <div
                    className="BuildPortfolio_holder_assetClass_pills__popup"
                    id={`${el.name.replace(
                      regex,
                      ""
                    )}-classification-${i}-${activePortfolioID}`}
                  >
                    <span className="BuildPortfolio_holder_assetClass_pills__popup_popuptext">
                      {el.min && el.max ? (
                        <SliderWithPercent
                          min={el.min * 100}
                          max={el.max * 100}
                          minMaxZeroToHundred={minMaxZeroToHundred}
                          ID={`${el.name.replace(
                            regex,
                            ""
                          )}-asset-slider-${activePortfolioID}`}
                          // its asset_class
                          group="asset_class"
                          name={el.name}
                          Sliderhandler={(obj) => sliderRangeHandler(obj)}
                          bg_warning={el.slider_error}
                        />
                      ) : null}
                    </span>
                  </div>
                )}
              </div>
            )
        )}
      </div>
    </Fragment>
  );
};

export default ClassificationGroup;



// WEBPACK FOOTER //
// ./src/components/common/treeTableWithSlider/ClassificationGroup.jsx